export const AUTO_RESOLVED_REFETCH_DEBOUNCE_MS = 1500;
export const AUTO_RESOLVED_SEEN_STORAGE_KEY_PREFIX = 'dobox:autoResolvedSeen';
export const AUTO_RESOLVED_DAYS_AGO_KEY = 'doBox.autoResolved.daysAgo';
export const AUTO_RESOLVED_DAY_KEY_FORMAT = 'YYYY-MM-DD';
export const WEEKDAY_SHORT_FORMAT = 'ddd';
